/**
 * Feedback schemas — the wire contract of `POST /api/feedback` and
 * `POST /api/feedback/nps`, validated by the API's `FeedbackController`.
 *
 * Feedback is filed into Sentry's feedback inbox (the system of record), so
 * `type` and `category` stay free-form short strings: the web widget, the
 * phone and business-web each send their own
 * vocabulary, and narrowing them here would refuse feedback a client already
 * sends.
 */

import { z } from 'zod';

/** A feedback submission (JSON, or multipart with `files` image attachments). */
export const submitFeedbackSchema = z.object({
  type: z.string().min(1).max(50),
  category: z.string().min(1).max(50),
  subject: z.string().min(1).max(200),
  message: z.string().min(1).max(10000),
  pageUrl: z.url().optional(),
  /** 1–5 star rating from the widget's first step (a string in multipart). */
  rating: z.coerce.number().int().min(1).max(5).optional(),
  /** Which portal filed it: journey-web | business-web | citizen-mobile. */
  portal: z.string().max(50).optional(),
});

/** A Net Promoter Score answer. */
export const submitNpsSchema = z.object({
  score: z.number().int().min(0).max(10),
  comment: z.string().max(2000).optional(),
});

export type SubmitFeedbackInput = z.infer<typeof submitFeedbackSchema>;
export type SubmitNpsInput = z.infer<typeof submitNpsSchema>;
